import { provideWidgetClass } from "scrivito"

export const GridWidgetClass = provideWidgetClass("GridWidget", {
  attributes: {
    items: "widgetlist"
  }
})
